import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

// LIST
export function getSamplesByFilter(params) {
  return axios.get(API_URL.SAMPLE_LIST, {params});
}

// READ
export function getSampleById(sampleId) {
  return axios.get(`${API_URL.SAMPLE_LIST}/${sampleId}`);
}

// Create
export function requestSample(goodsNo) {
  return axios.post(`${API_URL.SAMPLE_LIST}`, { goodsNo });
}
